// SocketIO
import * as io from "socket.io-client";

// Helpers
import Helpers from '.';

// Mobx
import SettingStore from '../mobx/stores/SettingStore';
import AppStore from '../mobx/stores/AppStore';
import DocumentStore from '../mobx/stores/DocumentStore';
import AnnouncementStore from '../mobx/stores/AnnouncementStore';
import AccountNumberStore from '../mobx/stores/AccountNumberStore';
import TrainingStore from '../mobx/stores/TrainingStore';
import ProductStore from '../mobx/stores/ProductStore';
import ProductCategoryStore from '../mobx/stores/ProductCategoryStore';
import ShoppingCartStore from '../mobx/stores/ShoppingCartStore';
import OrderStore from '../mobx/stores/OrderStore';
import CurrencyStore from '../mobx/stores/CurrencyStore';
import PaymentNotificationStore from '../mobx/stores/PaymentNotificationStore';
import PaymentTypeStore from '../mobx/stores/PaymentTypeStore';

const startSocket = () => {
    let socketIOConnectionConfig: any = {
        secure: true,
        jsonp: false,
        reconnection: true,
        reconnectionDelay: 100,
        reconnectionAttempts: 100000,
        transports: ['websocket'],
    };
    AppStore.setSocketIO(io.connect(SettingStore.settings.socketAddress, socketIOConnectionConfig));

    if (Helpers.getUserData().isLogin) {
        const storeId = localStorage.getItem('storeId');

        // Documents
        AppStore.socketIO.on('addDocument-' + storeId, function (response: any) {
            const documentData = response;

            if (DocumentStore.documents[documentData.id] === undefined) {
                DocumentStore.addDocument(documentData.id, {
                    id: documentData.id,
                    ...documentData.attributes
                })
            }
        });

        AppStore.socketIO.on('updateDocument-' + storeId, function (response: any) {
            const documentData = response;

            if (DocumentStore.documents['content'][documentData.id] !== undefined) {
                DocumentStore.updateDocument(documentData.id, {
                    id: documentData.id,
                    ...documentData.attributes
                })
            }
        });

        AppStore.socketIO.on('deleteDocument', function (response: any) {
            if (DocumentStore.documents.content[response] !== undefined) {
                DocumentStore.deleteDocument(response)
            }

            if (DocumentStore.searchDocuments.content[response] !== undefined) {
                DocumentStore.deleteSearchDocument(response)
            }
        });
        // Documents

        // Payment Types
        AppStore.socketIO.on('addPaymentType', function (response: any) {
            const paymentTypeData = response;

            if (PaymentTypeStore.paymentTypes[paymentTypeData.id] === undefined) {
                PaymentTypeStore.addPaymentType(paymentTypeData.id, {
                    id: paymentTypeData.id,
                    ...paymentTypeData.attributes
                })
            }
        });

        AppStore.socketIO.on('updatePaymentType', function (response: any) {
            const paymentTypeData = response;

            if (PaymentTypeStore.paymentTypes[paymentTypeData.id] !== undefined) {
                PaymentTypeStore.updatePaymentType(paymentTypeData.id, {
                    id: paymentTypeData.id,
                    ...paymentTypeData.attributes
                })
            }
        });

        AppStore.socketIO.on('deletePaymentType', function (response: any) {
            if (PaymentTypeStore.paymentTypes[response] !== undefined) {
                PaymentTypeStore.deletePaymentType(response)
            }
        });
        // Payment Types

        // Payment Notifications
        AppStore.socketIO.on('addPaymentNotification-' + Helpers.getUserData().id, function (response: any) {
            const paymentNotificationData = response;

            if (PaymentNotificationStore.paymentNotifications[paymentNotificationData.id] === undefined) {
                PaymentNotificationStore.addPaymentNotification(paymentNotificationData.id, {
                    id: paymentNotificationData.id,
                    ...paymentNotificationData.attributes
                })
            }
        });

        AppStore.socketIO.on('updatePaymentNotification' + storeId, function (response: any) {
            const paymentNotificationData = response;

            if (PaymentNotificationStore.paymentNotifications['content'][paymentNotificationData.id] !== undefined) {
                PaymentNotificationStore.updatePaymentNotification(paymentNotificationData.id, {
                    id: paymentNotificationData.id,
                    ...paymentNotificationData.attributes
                })
            }
        });

        AppStore.socketIO.on('deletePaymentNotification', function (response: any) {
            if (PaymentNotificationStore.paymentNotifications.content[response] !== undefined) {
                PaymentNotificationStore.deletePaymentNotification(response)
            }

            if (PaymentNotificationStore.searchPaymentNotifications.content[response] !== undefined) {
                PaymentNotificationStore.deleteSearchPaymentNotification(response)
            }
        });
        // Payment Notifications

        // Orders
        AppStore.socketIO.on('addOrder-' + Helpers.getUserData().id, function (response: any) {
            const orderData = response;

            if (OrderStore.orders[orderData.id] === undefined) {
                OrderStore.addOrder(orderData.id, {
                    id: orderData.id,
                    ...orderData.attributes
                })
            }
        });

        AppStore.socketIO.on('updateOrder-' + Helpers.getUserData().id, function (response: any) {
            const orderData = response;

            if (OrderStore.orders['content'][orderData.id] !== undefined) {
                OrderStore.updateOrder(orderData.id, {
                    id: orderData.id,
                    ...orderData.attributes
                })
            }
        });

        AppStore.socketIO.on('deleteOrder-' + Helpers.getUserData().id, function (response: any) {
            if (OrderStore.orders.content[response] !== undefined) {
                OrderStore.deleteOrder(response)
            }

            if (OrderStore.searchOrders.content[response] !== undefined) {
                OrderStore.deleteSearchOrder(response)
            }
        });
        // Orders

        // Shopping Carts
        AppStore.socketIO.on('addShoppingCart', function (response: any) {
            const shoppingCartData = response;

            if (ShoppingCartStore.shoppingCarts[shoppingCartData.id] === undefined) {
                ShoppingCartStore.addShoppingCart(shoppingCartData.id, {
                    id: shoppingCartData.id,
                    product_id: shoppingCartData.attributes.product.data.id,
                    ...shoppingCartData.attributes
                })
            }
        });

        AppStore.socketIO.on('updateShoppingCart', function (response: any) {
            const shoppingCartData = response;

            if (ShoppingCartStore.shoppingCarts[shoppingCartData.id] !== undefined) {
                ShoppingCartStore.updateShoppingCart(shoppingCartData.id, {
                    id: shoppingCartData.id,
                    product_id: shoppingCartData.attributes.product.data.id,
                    ...shoppingCartData.attributes
                })
            }
        });

        AppStore.socketIO.on('deleteShoppingCart', function (response: any) {
            if (ShoppingCartStore.shoppingCarts[response] !== undefined) {
                ShoppingCartStore.deleteShoppingCart(response)
            }
        });
        // Shopping Carts

        // Products
        AppStore.socketIO.on('addProduct-' + storeId, function (response: any) {
            const productData = response;

            if (ProductStore.products[productData.id] === undefined) {
                ProductStore.addProduct(productData.id, {
                    id: productData.id,
                    ...productData.attributes
                })
            }
        });

        AppStore.socketIO.on('updateProduct-' + storeId, function (response: any) {
            const productData = response;

            if (ProductStore.products['content'][productData.id] !== undefined) {
                ProductStore.updateProduct(productData.id, {
                    id: productData.id,
                    ...productData.attributes
                })
            }
        });

        AppStore.socketIO.on('deleteProduct', function (response: any) {
            if (ProductStore.products.content[response] !== undefined) {
                ProductStore.deleteProduct(response)
            }

            if (ProductStore.searchProducts.content[response] !== undefined) {
                ProductStore.deleteSearchProduct(response)
            }
        });
        // Products

        // ProductCategories
        AppStore.socketIO.on('addProductCategory', function (response: any) {
            const productCategoryData = response;

            if (ProductCategoryStore.productCategories[productCategoryData.id] === undefined) {
                ProductCategoryStore.addProductCategory(productCategoryData.id, {
                    ...ProductCategoryStore.productCategories[productCategoryData.id],
                    ...productCategoryData
                })
            }
        });

        AppStore.socketIO.on('updateProductCategory', function (response: any) {
            const productCategoryData = response;

            if (ProductCategoryStore.productCategories[productCategoryData.id] !== undefined) {
                ProductCategoryStore.updateProductCategory(productCategoryData.id, {
                    ...productCategoryData,
                    content: {},
                    page: 1,
                    pageCount: 1
                })
            }
        });

        AppStore.socketIO.on('deleteProductCategory', function (response: any) {
            if (ProductCategoryStore.productCategories[response] !== undefined) {
                ProductCategoryStore.deleteProductCategory(response)
            }
        });
        // ProductCategories

        // Announcements
        AppStore.socketIO.on('addAnnouncement', function (response: any) {
            const announcementData = response;

            if (AnnouncementStore.announcements[announcementData.id] === undefined) {
                AnnouncementStore.addAnnouncement(announcementData.id, announcementData)
            }
        });

        AppStore.socketIO.on('updateAnnouncement', function (response: any) {
            const announcementData = response;

            if (AnnouncementStore.announcements[announcementData.id] !== undefined) {
                AnnouncementStore.updateAnnouncement(announcementData.id, announcementData)
            }
        });

        AppStore.socketIO.on('deleteAnnouncement', function (response: any) {
            if (AnnouncementStore.announcements[response] !== undefined) {
                AnnouncementStore.deleteAnnouncement(response)
            }
        });
        // Announcements

        // Account Numbers
        AppStore.socketIO.on('addAccountNumber', function (response: any) {
            const accountNumberData = response;

            if (AccountNumberStore.accountNumbers[accountNumberData.id] === undefined) {
                AccountNumberStore.addAccountNumber(accountNumberData.id, {
                    id: accountNumberData.id,
                    ...accountNumberData.attributes
                })
            }
        });

        AppStore.socketIO.on('updateAccountNumber', function (response: any) {
            const accountNumberData = response;

            if (AccountNumberStore.accountNumbers[accountNumberData.id] !== undefined) {
                AccountNumberStore.updateAccountNumber(accountNumberData.id, {
                    id: accountNumberData.id,
                    ...accountNumberData.attributes
                })
            }
        });

        AppStore.socketIO.on('deleteAccountNumber', function (response: any) {
            if (AccountNumberStore.accountNumbers[response] !== undefined) {
                AccountNumberStore.deleteAccountNumber(response)
            }
        });
        // Account Numbers

        // Trainings
        AppStore.socketIO.on('addTraining-' + storeId, function (response: any) {
            const trainingData = response;

            if (TrainingStore.trainings[trainingData.id] === undefined) {
                TrainingStore.addTraining(trainingData.id, trainingData)
            }
        });

        AppStore.socketIO.on('updateTraining-' + storeId, function (response: any) {
            const trainingData = response;

            if (TrainingStore.trainings[trainingData.id] !== undefined) {
                TrainingStore.updateTraining(trainingData.id, trainingData)
            }
        });

        AppStore.socketIO.on('deleteTraining', function (response: any) {
            if (TrainingStore.trainings[response] !== undefined) {
                TrainingStore.deleteTraining(response)
            }
        });
        // Trainings

        // Currencies
        AppStore.socketIO.on('addCurrency', function (response: any) {
            const currencyData = response;

            if (CurrencyStore.currencies[currencyData.id] === undefined) {
                CurrencyStore.addCurrency(currencyData.id, currencyData)
            }
        });

        AppStore.socketIO.on('updateCurrency', function (response: any) {
            const currencyData = response;

            if (CurrencyStore.currencies[currencyData.id] !== undefined) {
                CurrencyStore.updateCurrency(currencyData.id, currencyData)
            }
        });

        AppStore.socketIO.on('deleteCurrency', function (response: any) {
            if (CurrencyStore.currencies[response] !== undefined) {
                CurrencyStore.deleteCurrency(response)
            }
        });
        // Currencies
    }
}

const exportHelpers = {
    startSocket,
}

export default exportHelpers;